/**
 * Hero 이미지 페이드 로테이션
 * - 5초 간격으로 다음 슬라이드 전환
 * - fade in / fade out
 */
const INTERVAL_MS = 5000;

export function initHeroSlider(root: ParentNode): () => void {
  const slider = root.querySelector<HTMLElement>('[data-hero-slider]');
  if (!slider) return () => undefined;

  const slides = Array.from(slider.querySelectorAll<HTMLElement>('.hero__slide'));
  if (slides.length < 2) return () => undefined;

  let index = slides.findIndex((slide) => slide.classList.contains('is-active'));
  if (index < 0) {
    index = 0;
    slides[0]?.classList.add('is-active');
  }

  const goTo = (nextIndex: number) => {
    const current = slides[index];
    const next = slides[nextIndex];
    if (!current || !next || nextIndex === index) return;

    current.classList.remove('is-active');
    next.classList.add('is-active');
    index = nextIndex;
  };

  const timer = window.setInterval(() => {
    goTo((index + 1) % slides.length);
  }, INTERVAL_MS);

  return () => {
    window.clearInterval(timer);
  };
}
